<template>
  <div>
    <v-btn text color="primary" class="ml-2" @click="dialog = true"
      >Add Service</v-btn
    >
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <ModalHeader
          title="Add Service"
          icon="mdi-plus-box"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <div v-if="ready">
            <v-row>
              <v-col
                ><v-text-field
                  outlined
                  dense
                  label="Search"
                  v-model="search"
                ></v-text-field
              ></v-col>
            </v-row>
            <div v-if="selected_service">
              <div class="d-flex">
                <div class="ma-3">
                  <p>Service Name:</p>
                  <h3 class="mt-n5">
                    {{ selected_service.service_name }}
                  </h3>
                </div>
                <div class="ma-3">
                  <p>Service Amount:</p>
                  <h3 class="mt-n5">
                    {{ selected_service.service_amount }}
                  </h3>
                </div>
              </div>
              <v-row>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    label="Quantity"
                    v-model="form.quantity"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    label="Total Price"
                    v-model="total_price"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    label="Remarks"
                    v-model="form.remarks"
                    rows="2"
                    outlined
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <v-btn color="" :loading="loading" @click="insert_service"
                    >Add</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-data-table
              :items-per-page="5"
              :search="search"
              :items="services"
              :headers="services_header"
            >
              <template v-slot:item.action="{ item }">
                <v-btn small color="primary" @click="add(item)">Select</v-btn>
              </template>
            </v-data-table>
          </div>
          <div v-else>
            <h2 class="text-center"></h2>
            Loading Data...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["invoice_id", "invoice_code"],
  async created() {
    this.check_if_exist();
    this.ready = true;
  },
  methods: {
    add(service) {
      this.selected_service = service;
    },

    async insert_service() {
      let x = await this.$confirm({
        title: "Add Service",
        message: "Are you sure you want to add this service?",
        color: "primary",
        icon: "mdi-plus",
      });
      if (x) {
        this.form.invoice_id = this.invoice_id;
        this.form.id = this.selected_service.id;
        this.form.total_amount = this.total_price;
        this.form.remarks = this.form.remarks || "";
        this.form.added_by = this.user ? this.user.full_name : "";
        this.form.date_added = new Date().toISOString().slice(0, 10);

        this.loading = true;
        this.add_service_to_invoice_items(this.form)
          .then((updatedInvoice) => {
            this.$alert({
              title: "Success",
              message: "Successfully added a new service!",
              color: "success",
              icon: "mdi-check-circle",
            });
            this.$emit("service-added", updatedInvoice);
            this.loading = false;
            this.dialog = false;
            this.selected_service = null;
            this.form.quantity = "";
            this.form.remarks = "";
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response &&
              err.response.status === 422 &&
              err.response.data.message
            ) {
              this.$alert({
                title: "Error",
                message: err.response.data.message,
                color: "error",
                icon: "mdi-alert-circle",
              });
              return;
            }
            this.$alert({
              title: "Error",
              message: String(err),
              color: "error",
              icon: "mdi-alert-circle",
            });
          });
      }
    },
    check_if_exist() {
      if (!this.services || this.services.length === 0) this.get_services();
    },
    ...mapActions({
      get_services: "service/get_services",
      add_service_to_invoice_items: "invoice/add_service_to_invoice_items",
    }),
  },
  computed: {
    ...mapGetters({
      services: "service/services",
      user: "auth/user",
    }),
    total_price() {
      let amount = this.selected_service.service_amount || 0;
      return amount * this.form.quantity;
    },
  },
  data() {
    return {
      loading: false,
      form: {
        quantity: "",
        remarks: "",
      },
      services_header: [
        { text: "Action", value: "action" },
        { text: "ID", value: "id" },
        { text: "Service Name", value: "service_name" },
        { text: "Service Amount", value: "service_amount" },
      ],
      search: "",
      selected_service: null,
      ready: false,
      dialog: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
